module.exports = __webpack_public_path__ + "static/media/annie-spratt-Iqwnr00mfQM-unsplash.52ce9955.jpg";